import * as React from 'react';
import PropTypes from 'prop-types';
import './header.scss';
import { StaticImage } from 'gatsby-plugin-image';
import { PERSONAL_LOAN, BASE_PATH } from 'gatsby-env-variables';
import InCredFinanceLogo from '../../images/InCred-logo.svg';
import InCredLogo from '../../images/InCred.svg';

interface Props {
  siteTitle?: string;
  showIconOnly?: boolean;
}

const Header: React.FunctionComponent<Props> = (props: Props) => {
  const [showMoreInfo, setShowMoreInfo] = React.useState('');
  const [showSideNav, setShowSideNav] = React.useState('');
  const [pathName, setPathName] = React.useState(false);

  const showMore = (element: string, status: boolean) => {
    setTimeout(
      () => {
        setShowMoreInfo(!status ? '' : element);
      },
      status ? 0 : 1000
    );
  };

  const sideNavFn = (element: string) => {
    setShowSideNav(showSideNav === element ? '' : element);
  };

  React.useEffect(() => {
    if (window.location.pathname.includes('Career-Page')) {
      setPathName(true);
    }
  });

  const headerOption = [
    {
      label: 'About Us',
      key: 'aboutus',
      dropdown: [
        { label: 'About InCred', url: `${BASE_PATH}about-us` },
        { label: 'Our Team', url: `${BASE_PATH}Team` },
        { label: 'In The News', url: `${BASE_PATH}InCred-News` },
        { label: 'Blog', url: '/blog/' },
        // { label: 'Podcasts', url: '/podcasts/' },
        { label: 'Partnerships', url: `${BASE_PATH}partnership` },
        { label: 'Careers', url: `${BASE_PATH}Career-Page/` },
        { label: 'CSR', url: `${BASE_PATH}InCred-CSR/` },
      ],
    },
    {
      label: 'Loans',
      key: 'loans',
      dropdown: [
        { label: 'Personal Loan', url: PERSONAL_LOAN },
        { label: 'Education Loan', url: '/el' },
        { label: 'SME Business Loan', url: '/sme-loan/index.html' },
        { label: 'Merchant Loan', url: BASE_PATH + 'merchant-loan/' },
      ],
    },
    { label: 'InCred Pronto', key: 'pronto', url: BASE_PATH + 'InCred-Pronto/' },
    {
      label: 'Contact Us',
      url: BASE_PATH + 'contact-us/',
    },
  ];

  const dropdownBlock = (items: any, view: any) => {
    return (
      <>
        <ul>
          {items.dropdown.map((item: any, index: any) => (
            <a href={item.url} key={`${item.label}-${index}-${view}`}>
              <li>{item.label}</li>
            </a>
          ))}
        </ul>
      </>
    );
  };

  return (
    <>
      {props.showIconOnly ? (
        <div className={`header-block z-3 shadow-2 ${showSideNav === 'sidenav' ? 'fixed' : ''}`}>
          <div className="flex align-items-center container justify-content-between">
            <div className="logo">
              <a href="/">
                <img src={InCredFinanceLogo} className="header-logo" />
              </a>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className={`header-block z-3 shadow-2 ${showSideNav === 'sidenav' ? 'fixed' : ''}`}>
            <div className="flex align-items-center container justify-content-between">
              {pathName || props.showIconOnly ? (
                <>
                  <div className="logo">
                    <a href="/">
                      <img src={InCredLogo} className="header-logo" />
                    </a>
                  </div>
                </>
              ) : (
                <>
                  <div className="logo">
                    <a href="/">
                      <img src={InCredFinanceLogo} className="header-logo" />
                    </a>
                  </div>

                  <div className="product-block flex">
                    {headerOption.map((item: any) => (
                      <div
                        className={`product-item ${item.dropdown === undefined ? 'no-dropdown' : ''}`}
                        key={`desktop-header-${item.key}`}
                        onMouseEnter={() => showMore(item.key, true)}
                        onMouseLeave={() => showMore(item.key, false)}
                      >
                        <span>{item.dropdown ? item.label : <a href={item.url}>{item.label}</a>}</span>
                        {item.dropdown && (
                          <>
                            <span className="product-dropdown-icon"></span>
                            <div
                              className={`animation-duration-300 product-dropdown z-3 ${showMoreInfo === item.key ? 'display' : ''}`}
                              onMouseEnter={() => showMore(item.key, true)}
                              onMouseLeave={() => showMore(item.key, false)}
                            >
                              {dropdownBlock(item, 'desktop')}
                            </div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </>
              )}
              {pathName ? (
                <>
                  <div className="pay-emi-block">
                    <div className="pay-emi">
                      <a href="#apply-now">Apply now</a>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="pay-emi-block">
                    <div className="pay-emi">
                      {' '}
                      <a href="/payment/payment.html"> Pay EMI</a>
                    </div>
                  </div>

                  <div className="sidenav-btn" onClick={() => sideNavFn('sidenav')}>
                    {showSideNav !== 'sidenav' ? (
                      <StaticImage
                        src="../../assets/icons/menu.png"
                        loading="eager"
                        width={24}
                        quality={95}
                        placeholder="none"
                        formats={['auto', 'webp']}
                        alt="Sidenav"
                      />
                    ) : (
                      <StaticImage
                        src="../../assets/icons/close.png"
                        loading="eager"
                        width={16}
                        quality={95}
                        placeholder="none"
                        formats={['auto', 'webp']}
                        alt="Sidenav"
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          </div>

          <div className={`sidenav-container shadow-2 z-5 ${showSideNav === 'sidenav' ? 'display' : ''}`}>
            <div className={`sidenav-block animation-duration-500 fadeinright`}>
              {headerOption.map((item: any, index: any) => (
                <div
                  className={`product-item ${item.dropdown === undefined ? 'no-dropdown' : ''} ${
                    index === headerOption.length - 1 ? 'border-none' : ''
                  }`}
                  onClick={() => showMore(item.key, showMoreInfo === item.key ? false : true)}
                  key={`mobile-header-${item.key}`}
                >
                  <div className="flex justify-content-between font_bold align-items-center">
                    <span>{item.dropdown ? item.label : <a href={item.url}>{item.label}</a>}</span>
                    <span
                      className={` ${showMoreInfo === item.key ? 'product-dropdown-icon-up' : 'product-dropdown-icon'} ${
                        item.dropdown ? '' : 'hidden'
                      }`}
                    ></span>
                  </div>
                  {item.dropdown && (
                    <>
                      <div className={`flex-none animation-duration-500 product-dropdown ${showMoreInfo === item.key ? 'display' : ''}`}>
                        {dropdownBlock(item, 'mobile')}
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string,
  showIconOnly: PropTypes.bool,
};

Header.defaultProps = {
  siteTitle: ``,
  showIconOnly: false,
};

export default Header;
